import React from 'react';
import { bool, func } from 'prop-types';

import { PromoSidecar } from '../promo-sidecar/PromoSidecar';
import { PromoSummaryTier } from './subcomponents/PromoSummaryTier';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import { noop } from '../../utils/promo-utils';

import './PromoSummary.scss';

export const PromoSummary = ({ isSummaryOpen, setIsSummaryOpen, isInPromoDrawer }) => {
  const { rewardTiers, isAnchorFulfillable, hasProducts } = usePromoModel();

  const handleClose = () => {
    setIsSummaryOpen(false);
  };

  return (
    <PromoSidecar
      isSidecarOpen={isSummaryOpen}
      setIsSidecarOpen={setIsSummaryOpen}
      useSidecarNav={isInPromoDrawer}
      useSidecarMask={!isInPromoDrawer}
      zIndex={1001}
    >
      <article
        className="promo-summary"
        data-testid="promo-summary"
      >
        <div className="promo-summary-header">
          <div className="promo-summary-header-messaging">
            <p className="promo-summary-header-messaging-title">Buy More Save More Tiers</p>
            <p className="promo-summary-header-messaging-secondary">View all promotion tiers below</p>
          </div>
          {(isAnchorFulfillable && !hasProducts) && (
            <button
              type="button"
              className="promo-summary-close"
              data-testid="promo-summary-close"
              aria-label="Close Drawer"
              onClick={handleClose}
            />
          )}
        </div>
        <div className="promo-summary-progress-bar">
          {rewardTiers.map((rewardTier, i) => (
            <PromoSummaryTier
              rewardTier={rewardTier}
              key={`promo-summary-tier-${i}`}
            />
          ))}
        </div>
      </article>
    </PromoSidecar>
  );

};

PromoSummary.displayName = 'PromoSummary';

PromoSummary.propTypes = {
  isSummaryOpen: bool,
  setIsSummaryOpen: func,
  isInPromoDrawer: bool
};

PromoSummary.defaultProps = {
  isSummaryOpen: false,
  setIsSummaryOpen: noop,
  isInPromoDrawer: false
};
